import { Link } from 'react-router-dom';

const footerLinks = {
  games: {
    title: '热门游戏',
    items: [
      { name: '经典麻将', path: '/categories?category=classic' },
      { name: '四川麻将', path: '/categories?category=regional' },
      { name: '广东麻将', path: '/categories?category=regional' },
      { name: '单机麻将', path: '/categories?category=single' },
    ],
  },
  guide: {
    title: '游戏指南',
    items: [
      { name: '新手入门', path: '/articles' },
      { name: '玩法技巧', path: '/articles' },
      { name: '麻将文化', path: '/articles' },
    ],
  },
  about: {
    title: '关于我们',
    items: [
      { name: '品牌介绍', path: '/about' },
      { name: '联系方式', path: '/about#contact' },
      { name: '用户协议', path: '/about' },
    ],
  },
};

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-50/80">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <Link to="/" className="text-xl font-heading text-background-50 hover:text-accent-400 transition-colors cursor-pointer">
                麻将游戏
              </Link>
              <p className="mt-3 text-sm text-background-50/60 leading-relaxed">
                免费经典麻将游戏在线玩，多种玩法模式，无需下载即开即玩。支持手机与电脑，随时随地享受正宗麻将对战乐趣。
              </p>
              <div className="flex items-center gap-3 mt-4">
                <a href="#" className="w-9 h-9 rounded-full bg-background-50/10 flex items-center justify-center hover:bg-accent-500 hover:text-background-50 transition-all cursor-pointer" aria-label="微信">
                  <i className="ri-wechat-line text-sm"></i>
                </a>
                <a href="#" className="w-9 h-9 rounded-full bg-background-50/10 flex items-center justify-center hover:bg-accent-500 hover:text-background-50 transition-all cursor-pointer" aria-label="微博">
                  <i className="ri-weibo-line text-sm"></i>
                </a>
                <a href="#" className="w-9 h-9 rounded-full bg-background-50/10 flex items-center justify-center hover:bg-accent-500 hover:text-background-50 transition-all cursor-pointer" aria-label="QQ">
                  <i className="ri-qq-line text-sm"></i>
                </a>
              </div>
            </div>

            {[footerLinks.games, footerLinks.guide, footerLinks.about].map((section) => (
              <div key={section.title}>
                <h4 className="text-sm font-semibold text-background-50 mb-4">
                  {section.title}
                </h4>
                <ul className="space-y-2.5">
                  {section.items.map((item) => (
                    <li key={item.name}>
                      <Link
                        to={item.path}
                        className="text-sm text-background-50/60 hover:text-accent-400 transition-colors cursor-pointer"
                        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                      >
                        {item.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="border-t border-background-50/10 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-background-50/40">
              &copy; {new Date().getFullYear()} 麻将游戏在线玩 - 保留所有权利
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-background-50/40 hover:text-background-50/70 transition-colors cursor-pointer">隐私政策</a>
              <a href="#" className="text-xs text-background-50/40 hover:text-background-50/70 transition-colors cursor-pointer">服务条款</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}